import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom'; // ✅ import BrowserRouter
import posthog from "posthog-js";

posthog.init("phc_fn80L64qSns3BNPNYR3kBHJRkeJOEoxmQMdp8HucJvI", {
  api_host: "https://us.i.posthog.com",
  autocapture: true,
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter> {/* ✅ wrap your app */}
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
